import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/InstructorViewFormativeSubmission/desktop';
import Mobile from 'pages/InstructorViewFormativeSubmission/mobile';
import { PageContext } from 'pages/InstructorViewFormativeSubmission/PageProvider';
import Tablet from 'pages/InstructorViewFormativeSubmission/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { studentSubmissions } = useApp();
    const { device } = useViewport();

    const contextProps = useContext(PageContext);

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...contextProps} />,
            tablet: <Tablet {...contextProps} />,
            desktop: <Desktop {...contextProps} />,
        }[device];
    };

    if (!studentSubmissions) return <Loading />;

    return <>{renderResponsiveLayout(device)}</>;
};

export default PageLayout;
